import { render, staticRenderFns } from "./TaskDriver.vue?vue&type=template&id=b4810f20&scoped=true&"
import script from "./TaskDriver.vue?vue&type=script&lang=js&"
export * from "./TaskDriver.vue?vue&type=script&lang=js&"
import style0 from "./TaskDriver.vue?vue&type=style&index=0&id=b4810f20&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4810f20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
